import Message from 'formvalidation/plugins/Message';
import Trigger from 'formvalidation/plugins/Trigger';
import SubmitButton from 'formvalidation/plugins/SubmitButton';

import ValidationUtils from '../../utils/validation';

const personalDetailsValidationRules = {
	fields: {
		firstName: {
			validators: {
				notEmpty: {
					message: 'Please enter a first name'
				},
				stringLength: {
					min: 2,
					message: 'First name must be 2 or more letters'
				},
				regexp: {
					regexp: /^[a-zA-Z-' ]+$/,
					message: 'Please enter a first name that contains only letters'
				}
			}
		},
		lastName: {
			validators: {
				notEmpty: {
					message: 'Please enter a last name'
				},
				stringLength: {
					min: 2,
					message: 'Last name must be 2 or more letters'
				},
				regexp: {
					regexp: /^[a-zA-Z-' ]+$/,
					message: 'Please enter last name that contains only letters'
				}
			}
		},
		emailAddress: {
			validators: {
				notEmpty: {
					message: 'Please enter an email address'
				},
				regexp: {
					regexp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
					message: 'Please enter a valid email address'
				}
			}
		},
		gender: {
			validators: {
				notEmpty: {
					message: 'Please select a gender'
				}
			}
		},
		universityStudent: {
			validators: {
				notEmpty: {
					message: 'Please select if you are currently studying at university'
				}
			}
		},
		university: {
			validators: {
				notEmpty: {
					message: 'Please select a university'
				}
			}
		},
		graduationYear: {
			validators: {
				notEmpty: {
					message: 'Please select a graduation year'
				}
			}
		}
	},
	plugins: {
		trigger: new Trigger(),
		submitButton: new SubmitButton(),
		message: new Message({
			clazz: 'lta-text-input__label-instruction',
			container: function(field, element) {
				let fieldType = element.getAttribute('type') || element.nodeName.toLowerCase();
				const inputWrapper = element.closest(ValidationUtils.getFieldWrapper(fieldType));
				return inputWrapper.querySelector('.lta-text-input--error');
			}
		}),
	}
}

export default personalDetailsValidationRules;
